export default ({ big }) => [
  {
    title: 'Название', value: big.fontSize1, paramName: 'fontSize1', parentName: 'big',
  },
  {
    title: 'Значение', value: big.fontSize2, paramName: 'fontSize2', parentName: 'big',
  },
];
